module.exports = __webpack_public_path__ + "static/media/niatv_online_dance_workouts.e194cb71.webp";